<template>
  <footer>
    <div class="container">
      <div class="top">
        <div class="col-md-4 top-col align-start">
          <img class="logo" src="@/assets/img/auzoneLogo.svg" alt="image">
          <p>Founded in 2001 as a pioneer in the embedded design and computer vision industry, Au-Zone has become a trusted provider of embedded AI and machine learning (ML) software, hardware and reference designs for 3D spatial perception in unstructured and harsh environments.</p>
          <br>
          <span class="scroll-animated-from-bottom">© 2025 by Au-Zone Technologies</span>
        </div>
        <div class="col-md-4 top-col">
          <div class="links">
            <a href="https://edgefirst.ai" target="_blank" rel="noopener">EdgeFirst AI</a>
            <a href="https://edgefirst.ai/about-us" target="_blank" rel="noopener">About Us</a>
            <a href="https://edgefirst.ai/partners" target="_blank" rel="noopener">Partners</a>
            <a href="https://edgefirst.ai/news" target="_blank" rel="noopener">Media and Events</a>
            <a href="https://edgefirst.ai/services" target="_blank" rel="noopener">Services</a>
          </div>
        </div>
        <div class="col-md-4 top-col text-center">
          <p>
            Au-Zone Technologies<br>
            #302 - 1240 20 Ave SE<br>
            Calgary AB T2G 1M8
          </p>
          <p class="mt-4">
            support@au-zone.com
          </p>
          <p class="mt-1">
            403.261.9985
          </p>
          <div class="mt-4 social">
            <a
              href="https://www.linkedin.com/company/au-zone-technologies"
              target="_blank"
              rel="noopener"
            >
              <img
                src="@/assets/landing-page/assets/images/linkedin_white.png"
                alt="image"
              >
            </a>
            <a
              href="https://www.youtube.com/@Au-zone"
              target="_blank"
              rel="noopener"
            >
              <img
                src="@/assets/landing-page/assets/images/youtube_line.svg"
                alt="image"
              >
            </a>
          </div>
        </div>
      </div>
      <div class="bottom">
        <button class="back-to-top-btn" @click="$emit('scroll-to-top')">
          <SVGIcon
            :width="'24px'"
            :height="'24px'"
            :iconName="'double_arrow_up'"
          />
          Back To Top
        </button>
      </div>
    </div>
  </footer>
</template>

<script setup>
import SVGIcon from '@/components/SVGIcon.vue';

defineEmits(['scroll-to-top']);
</script>

<style lang="scss" scoped>
footer {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  background-image: url('@/assets/landing-page/assets/images/footer.svg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
}

.container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.top {
  display: flex;
  flex-direction: row;
  margin: 2rem 2rem 0 2rem;
}

@media (max-width: $breakpoint-md) {
  .top {
    flex-direction: column;
    gap: 1rem;
  }
}

.top-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.links {
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: center;
}

.logo {
  height: 100px;
}

.bottom {
  display: flex;
  flex-direction: row;
  margin: 0 2rem 2rem 2rem;
}

.social {
  height: 30px;
  gap: 8px;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;

  img {
    height: 100%;
    cursor: pointer;
  }
}

.back-to-top-btn {
  border: 1px solid white;
  border-radius: 2px;
  margin: auto;
  width: fit-content;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 2px 6px;
}

a {
  color: #cccccc;
  text-decoration: none;
  transition: color 0.2s;
  cursor: pointer;
}

a:hover {
  color: #9370db;
  text-decoration: underline;
}

a:visited {
  color: #cccccc;
}
</style>
